import image from '../../assets/images/portfolios/portfolio1.webp'

function BlogSection() {
	return (
		<section className='mt-[50px] sm:mt-[70px]' id='blog'>
			<div className='flex flex-col items-center'>
				<p className='text-center text-black dark:text-white font-medium text-[20px] sm:text-[26px] xl:text-[32px]'>
					Блог
				</p>
				<p className='mt-[15px] text-dark-100 sm:mt-[25px] text-center w-[300px] sm:w-[360px]'>
					Тут я публикую интересную информацию, прогресс учебы и
					работы, актуальные IT новости.
				</p>
			</div>
			<div className='mt-[50px] grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-[24px]'>
				<div className='w-full bg-white dark:bg-dark-300'>
					<img src={image} alt='alt' />
					<div className='px-[16px] py-[25px]'>
						<p className='text-[18px] font-medium text-black dark:text-white h-[50px] line-clamp-2'>
							Как сделать веб-сайт макет.
						</p>
						<p className='mt-[14px] text-dark-100 line-clamp-3 h-[70px]'>
							Чтобы сделать веб-сайт на тильде, вам нужно создать
							аккаунт.
						</p>
						<div className='mt-[17px] h-full'>
							<a href='#' className='text-yellow-100 font-medium'>
								{'Читать дальше >'}
							</a>
						</div>
					</div>
				</div>
				<div className='w-full bg-white dark:bg-dark-300'>
					<img src={image} alt='alt' />
					<div className='px-[16px] py-[25px]'>
						<p className='text-[18px] font-medium text-black dark:text-white h-[50px] line-clamp-2'>
							Как продвинуть минимально сайт самостоятельно.
						</p>
						<p className='mt-[14px] text-dark-100 line-clamp-3 h-[70px]'>
							Изучите другие похожие сайты по вашему типу, зайдите
							на сайт Яндекса.
						</p>
						<div className='mt-[17px]'>
							<a href='#' className='text-yellow-100 font-medium'>
								{'Читать дальше >'}
							</a>
						</div>
					</div>
				</div>
				<div className='w-full bg-white dark:bg-dark-300'>
					<img src={image} alt='alt' />
					<div className='px-[16px] py-[25px]'>
						<p className='text-[18px] font-medium text-black dark:text-white h-[50px] line-clamp-2'>
							Как сделать карточку для быстрой связи с вами.
						</p>
						<p className='mt-[14px] text-dark-100 line-clamp-3 h-[70px]'>
							Вы можете воспользоваться сайтом taplink и туда
							вставьте ссылки на свои соц. сети.
						</p>
						<div className='mt-[17px]'>
							<a href='#' className='text-yellow-100 font-medium'>
								{'Читать дальше >'}
							</a>
						</div>
					</div>
				</div>
				<div className='w-full bg-white dark:bg-dark-300'>
					<img src={image} alt='alt' />
					<div className='px-[16px] py-[25px]'>
						<p className='text-[18px] font-medium text-black dark:text-white h-[50px] line-clamp-2'>
							Как добавить кнопку в Elementor Pro.
						</p>
						<p className='mt-[14px] text-dark-100 line-clamp-3 h-[70px]'>
							Для создания кнопки в Elementor Pro выберите ее для
							начала в левой части.
						</p>
						<div className='mt-[17px]'>
							<a href='#' className='text-yellow-100 font-medium'>
								{'Читать дальше >'}
							</a>
						</div>
					</div>
				</div>
				<div className='w-full bg-white dark:bg-dark-300'>
					<img src={image} alt='alt' />
					<div className='px-[16px] py-[25px]'>
						<p className='text-[18px] font-medium text-black dark:text-white h-[50px] line-clamp-2'>
							Что нужно для написания статьи.
						</p>
						<p className='mt-[14px] text-dark-100 line-clamp-3 h-[70px]'>
							Изучите как пишут другие и найдите свой стиль.
						</p>
						<div className='mt-[17px]'>
							<a href='#' className='text-yellow-100 font-medium'>
								{'Читать дальше >'}
							</a>
						</div>
					</div>
				</div>
			</div>
		</section>
	)
}

export default BlogSection
